import { apiClient } from '../helpers';

const assignExamToStudents = (exam_id: number, user_ids: number[]) => {
  return apiClient.post('/api/exam-assignments/assign', {
    exam_id,
    user_ids,
  })
    .then(response => response.data)
    .catch(error => {
      console.error('Error assigning exam:', error);
      throw error;
    });
};

const getStudentAssignedExams = (user_id: number) => {
  return apiClient.get(`/api/exam-assignments/user/${user_id}`)
    .then(response => ({ data: response.data }))
    .catch(error => {
      console.error('Error getting assigned exams:', error);
      throw error;
    });
};

const getExamAssignedStudents = (exam_id: number) => {
  return apiClient.get(`/api/exam-assignments/exam/${exam_id}/students`)
    .then(response => ({ data: response.data }))
    .catch(error => {
      console.error('Error getting assigned students:', error);
      throw error;
    });
};

const updateAssignmentStatus = (assignment_id: number, data: any) => {
  return apiClient.put(`/api/exam-assignments/${assignment_id}`, data)
    .then(response => response.data)
    .catch(error => {
      console.error('Error updating assignment:', error);
      throw error;
    });
};

const deleteAssignment = (assignment_id: number) => {
  return apiClient.delete(`/api/exam-assignments/${assignment_id}`)
    .then(response => response.data)
    .catch(error => {
      console.error('Error deleting assignment:', error);
      throw error;
    });
};

export const examAssignmentService = {
  assignExamToStudents,
  getStudentAssignedExams,
  getExamAssignedStudents,
  updateAssignmentStatus,
  deleteAssignment,
};
